import { OrgNameMapping } from './enums/organization';

export const isLennar = (orgName?: string) => orgName === OrgNameMapping.Lennar || orgName === undefined;
export const isToll = (orgName?: string) => orgName === OrgNameMapping.Toll;
